import type { Cycle as CycleContent } from '../api/types';
import { Reveal } from './Reveal';
import styles from './Cycle.module.css';

export function Cycle({ cycle }: { cycle: CycleContent }) {
  return (
    <section className="section" id="how">
      <div className="shell">
        <Reveal className="sectionHead">
          <p className="eyebrow">{cycle.eyebrow}</p>
          <h2>{cycle.title}</h2>
          <p className="lead">{cycle.body}</p>
        </Reveal>

        <Reveal>
          <ol className={styles.stations}>
            {cycle.stations.map((station) => (
              <li key={station.step} className={styles.station}>
                <span className={styles.step}>
                  {station.step} — {station.name}
                </span>
                <h3>{station.title}</h3>
                <p className={styles.body}>{station.body}</p>
              </li>
            ))}
          </ol>

          <p className={styles.return}>
            <span>{cycle.returnLabel}</span>
            <span className={styles.line} aria-hidden="true">
              <span className={styles.runner} />
            </span>
            <span>{cycle.cadence}</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
